'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'stroopwafel';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f551';
var svgPathData = 'M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM75 188.1L52.4 210.7l11.3 11.3L97.6 256 63.7 289.9 52.4 301.3 75 323.9l11.3-11.3 33.9-33.9 45.3 45.3-56.6 56.6L97.6 391.8l22.6 22.6 11.3-11.3 56.6-56.6 45.3 45.3-33.9 33.9L188.1 437l22.6 22.6 11.3-11.3L256 414.4l33.9 33.9 11.3 11.3L323.9 437l-11.3-11.3-33.9-33.9 45.3-45.3 56.6 56.6 11.3 11.3 22.6-22.6-11.3-11.3-56.6-56.6 45.3-45.3 33.9 33.9L437 323.9l22.6-22.6-11.3-11.3L414.4 256l33.9-33.9 11.3-11.3L437 188.1l-11.3 11.3-33.9 33.9-45.3-45.3 56.6-56.6 11.3-11.3L391.8 97.6l-11.3 11.3-56.6 56.6-45.3-45.3 33.9-33.9L323.9 75 301.3 52.4 289.9 63.7 256 97.6 222.1 63.7 210.7 52.4 188.1 75l11.3 11.3 33.9 33.9-45.3 45.3-56.6-56.6L120.2 97.6 97.6 120.2l11.3 11.3 56.6 56.6-45.3 45.3L86.3 199.4 75 188.1zm181 181l-45.3-45.3L256 278.6l45.3 45.3L256 369.1zm67.9-67.9L278.6 256l45.3-45.3L369.1 256l-45.3 45.3zM210.7 188.1L256 142.9l45.3 45.3L256 233.4l-45.3-45.3zm-22.6 22.6L233.4 256l-45.3 45.3L142.9 256l45.3-45.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStroopwafel = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;